import axios from 'axios'
import qs from 'qs'
import { toast } from 'vue-sonner'
import { client } from 'laravel-precognition-vue'
import { clear } from 'idb-keyval'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
    baseURL: import.meta.env.VITE_APP_API_URL,
    withCredentials: true, // Check cross-site Access-Control
    withXSRFToken: true,
}

const httpClient = axios.create(config)

export const httpClientWithoutInterceptors = axios.create(config)

window.axios = httpClientWithoutInterceptors

client.use(window.axios)

export function setupInterceptors() {
    httpClient.interceptors.request.use(
        (config) => {
            config.paramsSerializer = (params) => qs.stringify(params)
            return config
        },
        (error) => Promise.reject(error)
    )

    // Add a response interceptor
    httpClient.interceptors.response.use(
        (response) => response,
        async (error) => {
            const {
                response: { status },
            } = error
            const hidden = [422, 401, 419]

            if (hidden.indexOf(status) === -1) {
                let title = 'Internal Server Error'
                let description = error.response.data.message || error.response.data.exception

                if (!description) {
                    const text = JSON.parse(await error.response.data.text())
                    description = text.message || text.exception
                }

                if (status === 403) {
                    title = '403 Unauthorized'
                }

                if (status === 404) {
                    title = '404 Not found'
                }

                toast.error(title, {
                    description,
                    duration: 3600000,
                    position: 'top-center',
                })
            }

            if (status === 419) {
                return httpClient.get('csrf-cookie').then(
                    () =>
                        new Promise((resolve, reject) => {
                            httpClient
                                .request(error.response.config)
                                .then((response) => resolve(response))
                                .catch((error) => reject(error))
                        })
                )
            }

            if (status === 401) {
                await clear()
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login'
                }
            }

            return Promise.reject(error)
        }
    )

    httpClientWithoutInterceptors.interceptors.response.use(
        (response) => response,
        async (error) => {
            const {
                response: { status },
            } = error

            if (status === 419) {
                return httpClient.get('csrf-cookie').then(
                    () =>
                        new Promise((resolve, reject) => {
                            httpClient
                                .request(error.response.config)
                                .then((response) => resolve(response))
                                .catch((error) => reject(error))
                        })
                )
            }

            if (status === 401) {
                await clear()
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login'
                }
            }

            return Promise.reject(error)
        }
    )
}

export default httpClient
